/*
 * Euroville — proteção de seminovos no carrinho (2026-10-05).
 * Seminovo é só consulta e contato: se um veículo entrar no carrinho por qualquer caminho que passe pelo
 * navegador (botão de app, recomendação, script, carrinho antigo), este script o remove e avisa.
 * Limite: é proteção do tema. Um link direto de checkout ou uma chamada à API fora do site não passa por aqui.
 * As tags vêm de window.EUROVILLE_SEMINOVOS_TAGS, gerado pelo snippet seminovo-flag (fonte única).
 */
(function () {
  var TAGS = (window.EUROVILLE_SEMINOVOS_TAGS || '').split(',').filter(Boolean);
  if (!TAGS.length || !window.fetch) return;
  var CACHE_KEY = 'ev_seminovo_handles_v2';
  var origFetch = window.fetch.bind(window);
  var running = null;
  var tentativas = 0;

  function loadCache() { try { return JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { return {}; } }
  function saveCache(c) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) {} }

  function isVehicleHandle(handle, cache) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) return Promise.resolve(cache[handle]);
    return origFetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null; // falha na consulta: resultado desconhecido, não vai para o cache
        var tags = p.tags || [];
        if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
        var v = tags.some(function (t) { return TAGS.indexOf(t) !== -1; });
        cache[handle] = v;
        return v;
      })
      .catch(function () { return null; });
  }

  function toast(msg) {
    var el = document.getElementById('ev-seminovo-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ev-seminovo-toast';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:92vw;background:#1c1c1c;color:#fff;padding:14px 18px;border-radius:8px;font-size:14px;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,.25)';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.remove(); }, 9000);
  }

  function refreshBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    origFetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var html = s && s['cart-icon-bubble'];
      if (!html) return;
      var d = document.createElement('div');
      d.innerHTML = html;
      var inner = d.querySelector('.shopify-section') || d;
      bubble.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  function check() {
    if (running) return running;
    running = origFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) return 0;
        var cache = loadCache();
        return Promise.all(items.map(function (it) { return isVehicleHandle(it.handle, cache); })).then(function (flags) {
          saveCache(cache);
          var updates = {};
          var n = 0;
          var desconhecidos = 0;
          items.forEach(function (it, i) { if (flags[i] === true) { updates[it.key] = 0; n++; } else if (flags[i] === null) desconhecidos++; });
          if (desconhecidos && tentativas < 5) { tentativas++; setTimeout(check, 2000 * tentativas); }
          if (!n) return 0;
          return origFetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () {
            toast('Veículos seminovos não podem ser comprados online. O veículo foi retirado do carrinho. Fale com um vendedor pelo botão "Fale com um vendedor" na página do veículo.');
            if (/^\/cart\/?$/.test(location.pathname)) { setTimeout(function () { location.reload(); }, 1500); }
            else refreshBubble();
            return n;
          });
        });
      })
      .catch(function () { return 0; })
      .then(function (n) { running = null; return n; });
    return running;
  }

  // Recheca depois de qualquer inclusão no carrinho feita por fetch no navegador (apps, recomendações, scripts).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(check, 50); }).catch(function () {});
    }
    return p;
  };

  // Antes de seguir para o checkout pelo carrinho, confere de novo.
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (!sub || sub.name !== 'checkout') return;
    var form = e.target;
    if (form.dataset.evChecked === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    check().then(function (removed) {
      if (removed) return;
      form.dataset.evChecked = '1';
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '';
      form.appendChild(h);
      form.submit();
    });
  }, true);

  window.EurovilleSeminovosGuard = { check: check };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
